(function () {
  'use strict';

  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function CollectionPage(root) {
    if (!root || root.getAttribute('data-cp-initialized') === 'true') return;

    root.setAttribute('data-cp-initialized', 'true');
    this.root = root;
    this.openButton = root.querySelector('[data-cp-filter-open]');
    this.drawer = root.querySelector('[data-cp-filter-drawer]');
    this.drawerPanel = root.querySelector('[data-cp-filter-panel]');
    this.closeButtons = root.querySelectorAll('[data-cp-filter-close]');
    this.sortSelects = root.querySelectorAll('[data-cp-sort-select]');
    this.desktopFilterForm = root.querySelector('[data-cp-desktop-filters]');
    this.lastFocusedElement = null;

    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.bindSort();
    this.bindDesktopFilters();
    this.bindDrawer();
  }

  CollectionPage.prototype.bindSort = function () {
    Array.prototype.forEach.call(this.sortSelects, function (select) {
      select.addEventListener('change', function () {
        var form = select.form;
        if (!form) return;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
  };

  CollectionPage.prototype.submitForm = function (form) {
    if (!form) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  };

  CollectionPage.prototype.bindDesktopFilters = function () {
    var instance = this;

    if (!this.desktopFilterForm) return;

    this.desktopFilterForm.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="checkbox"]')) return;
      instance.submitForm(instance.desktopFilterForm);
    });
  };

  CollectionPage.prototype.bindDrawer = function () {
    var instance = this;

    if (!this.openButton || !this.drawer || !this.drawerPanel) return;

    this.openButton.addEventListener('click', function () {
      instance.openDrawer();
    });

    Array.prototype.forEach.call(this.closeButtons, function (button) {
      button.addEventListener('click', function () {
        instance.closeDrawer(true);
      });
    });

    window.addEventListener('resize', this.handleResize);
  };

  CollectionPage.prototype.openDrawer = function () {
    this.lastFocusedElement = document.activeElement;
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.openButton.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('cp-filter-drawer-open');
    document.body.classList.add('cp-filter-drawer-open');
    document.addEventListener('keydown', this.handleKeydown);

    var firstFocusable = this.drawerPanel.querySelector(focusableSelector);
    if (firstFocusable) firstFocusable.focus();
  };

  CollectionPage.prototype.closeDrawer = function (restoreFocus) {
    if (!this.drawer || !this.drawer.classList.contains('is-open')) return;

    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.openButton.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('cp-filter-drawer-open');
    document.body.classList.remove('cp-filter-drawer-open');
    document.removeEventListener('keydown', this.handleKeydown);

    if (restoreFocus && this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
      this.lastFocusedElement.focus();
    }
  };

  CollectionPage.prototype.handleKeydown = function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeDrawer(true);
      return;
    }

    if (event.key !== 'Tab') return;

    var focusableElements = this.drawerPanel.querySelectorAll(focusableSelector);
    if (!focusableElements.length) {
      event.preventDefault();
      this.drawerPanel.focus();
      return;
    }

    var firstElement = focusableElements[0];
    var lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  };

  CollectionPage.prototype.handleResize = function () {
    if (window.innerWidth >= 990) this.closeDrawer(false);
  };

  function initialize(scope) {
    var context = scope || document;
    var roots = context.querySelectorAll('[data-cp-collection]');

    Array.prototype.forEach.call(roots, function (root) {
      new CollectionPage(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
